export default "__VITE_ASSET__C76Y06di__"